export default "__VITE_ASSET__BwIm1M3v__"